import React,{useState,useEffect} from 'react'
import Box from '@mui/material/Box';
import {Typography,Button,Grid,} from '@mui/material';
import {makeStyles} from '@mui/styles';
import Divider from '@mui/material/Divider'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const useStyles = makeStyles((theme)=>({
    workExperienceContainer:{
        width:'700px',height:'1200px',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',

        [theme.breakpoints.down("800")]:{
            alignItems:'normal',
            height:'100%',
            width:'100%'
        }
    },
    aboutHeader:{
        color:'#64ffda',
        fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",
        fontSize:'10vw',
        

    },aboutMe:{
        marginInline:'10px',color:'#ccd6f6',
        [theme.breakpoints.down("800")]:{
            fontSize:'8vw'
           
        }
    },divider:{
        width:'200px',
        backgroundColor:'#233554',
        alignSelf:'center',
        [theme.breakpoints.down("800")]:{
          width:'50px'
        }
    },
    headingContainer:{
        
        height:'40px',
        width:'100%'
    },
    contentContainer:{
        display:'flex',
        flexDirection:'row',
        width:'100%',
        marginTop:'25px',
        [theme.breakpoints.down("800")]:{
            width:'100%',
            flexDirection:'column'
          }
    },
    listContainer:{
       
        width:'25%',
        [theme.breakpoints.down("800")]:{
           width:window.innerWidth-30,overflow:'auto'
          }
    },list:{
        [theme.breakpoints.down("800")]:{
            width:'100%',
            display:'flex',
            flexDirection:'row'
           }
    },
    descriptionContainer:{
      
        width:'75%',
        display:'flex',
        alignItems:'flex-start',
        justifyContent:'flex-start',
        flexDirection:'column',
        marginLeft:'25px',
        [theme.breakpoints.down("800")]:{
            width:'99%',
            marginLeft:'5px'
           }
    },
    roleContainer:{
        display:'flex',
        flexDirection:'row',
        [theme.breakpoints.down("800")]:{
            width:'100%',
            flexDirection:'column',
            padding:'5px'
           }
    },
    roleTime:{
        [theme.breakpoints.down("800")]:{
           
            paddingLeft:'10px'
           }
    },
    descriptionPoints:{
        marginTop:'30px'
    },
    roleName:{
        [theme.breakpoints.down("800")]:{
          paddingLeft:'10px'
           }
    },
    companyName:{
        [theme.breakpoints.down("800")]:{
            margin:'0px'
           }
    },
    point:{
        maxWidth:'600px',
        [theme.breakpoints.down("800")]:{
            maxWidth:'100%'
           }
    }
    
}))

const WorkExperience = ({refer}) => {
    const classes = useStyles()
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
     const [openDrawer,setOpenDrawer] = useState(false)
     const [selectedIndex,setSelectedIndex] = useState(1)
    
    useEffect(()=>{
       
    },[refer])

     useEffect(() => {
       function handleResize() {
         setWindowWidth(window.innerWidth)
       }
   
       window.addEventListener('resize', handleResize)
       return () => window.removeEventListener('resize', handleResize)
     }, [])
    return (
        <div ref={refer} style={{display:"flex",alignItems:'center',justifyContent:'center',marginTop:'50px'}} >
            
            
            <Box className={classes.workExperienceContainer} >
                
                <Box className={ classes.headingContainer} >
                    <Box style={{display:'flex',flexDirection:'row'}} className={classes.aboutMeContainer}>
                        <Typography className={classes.aboutHeader} style={{fontSize:'22px',alignSelf:'center',margin:"0px 5px 0px 5px",fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>02.</Typography>
                        <Typography className={classes.aboutMe} style={{fontSize:'26px',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Where I've Worked</Typography>
                        <Divider orientation="horizontal"  className={classes.divider}/>
                    </Box>
                </Box>
                {/*Juniper Software Engineer 2 */}
                <Box className={classes.contentContainer}>

                    <Box  className={classes.listContainer,"listContainer"}>
                        <List className={classes.list}>
                            <ListItem disablePadding>
                                <ListItemButton selected={selectedIndex===1} style={{borderLeft:selectedIndex==1?'1px solid #64ffda':'none'}}> 
                                    <ListItemText primary="Juniper Networks" style={{color:'#64ffda'}}/>
                                </ListItemButton>
                            </ListItem>

                        
                        </List>
                    </Box>

                    <Box className={classes.descriptionContainer} >
                        <Box  className={classes.roleContainer}>
                            <Typography className={classes.roleName} style={{color:'#ccd6f6',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",fontSize:'22px'}}>Software Engineer 2</Typography>
                            <Typography  className={classes.companyName} style={{color:'#64ffda',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",margin:'0px 5px 0px 5px',fontSize:'22px'}}>@Juniper Networks</Typography>
                        </Box>
                        <Typography className={classes.roleTime} style={{color:'#495670',fontSize:'13px',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Jul 2024 - current</Typography>
                        
                        {/*Content
                        <Box  className={classes.descriptionPoints}>
                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography variant="body2" className={classes.point} style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                    Developed contemporary, efficient, and sustainable code for internal projects.
                                </Typography>
                            </Box>

                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                    Worked on development of internal tools using python, psql, sql, elasticdb, JunosCLI, regex, etc,..
                                </Typography>
                            </Box>

                            
                        </Box> */}
                    </Box>
                
                </Box>

                <br></br>
                <br></br>


                {/*Juniper Software Engineer 1 */}
                <Box className={classes.contentContainer}>

                    <Box  className={classes.listContainer,"listContainer"}>
                        <List className={classes.list}>
                            <ListItem disablePadding>
                                <ListItemButton selected={selectedIndex===1} style={{borderLeft:selectedIndex==1?'1px solid #64ffda':'none'}}> 
                                    <ListItemText primary="Juniper Networks" style={{color:'#64ffda'}}/>
                                </ListItemButton>
                            </ListItem>

                        
                        </List>
                    </Box>

                    <Box className={classes.descriptionContainer} >
                        <Box  className={classes.roleContainer}>
                            <Typography className={classes.roleName} style={{color:'#ccd6f6',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",fontSize:'22px'}}>Software Engineer 1</Typography>
                            <Typography  className={classes.companyName} style={{color:'#64ffda',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",margin:'0px 5px 0px 5px',fontSize:'22px'}}>@Juniper Networks</Typography>
                        </Box>
                        <Typography className={classes.roleTime} style={{color:'#495670',fontSize:'13px',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Jul 2023 - Jul 2024</Typography>
                        
                        {/*Content */}
                        <Box  className={classes.descriptionPoints}>
                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography variant="body2" className={classes.point} style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Worked on supporting openconfig standards for configuring and streaming data
                                for Junos OS for Interfaces and Platforms technology area using Cpp .
                                </Typography>
                            </Box>

                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Single handedly built and deployed a fullstack internal tool using
                                react,psql,tailwindcss,nodejs,nginx,docker etc
                                </Typography>
                            </Box>

                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Improvized some of the algorithms used for log parsing by 200%
                                </Typography>
                            </Box>

                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Worked on writing test-scripts using golang and have contributed to google's
                                opensource project ONDATRA.
                                </Typography>
                            </Box>

                            
                        </Box>
                    </Box>
                
                </Box>

                <br></br>
                <br></br>


                {/*Juniper Internship */}
                <Box className={classes.contentContainer}>

                    <Box  className={classes.listContainer,"listContainer"}>
                        <List className={classes.list}>
                            <ListItem disablePadding>
                                <ListItemButton selected={selectedIndex===1} style={{borderLeft:selectedIndex==1?'1px solid #64ffda':'none'}}> 
                                    <ListItemText primary="Juniper Networks" style={{color:'#64ffda'}}/>
                                </ListItemButton>
                            </ListItem>

                        
                        </List>
                    </Box>

                    <Box className={classes.descriptionContainer} >
                        <Box  className={classes.roleContainer}>
                            <Typography className={classes.roleName} style={{color:'#ccd6f6',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",fontSize:'22px'}}>Software Engineer Intern</Typography>
                            <Typography  className={classes.companyName} style={{color:'#64ffda',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",margin:'0px 5px 0px 5px',fontSize:'22px'}}>@Juniper Networks</Typography>
                        </Box>
                        <Typography className={classes.roleTime} style={{color:'#495670',fontSize:'13px',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Jan 2023 - Jul 2023</Typography>
                        
                        {/*Content */}
                        <Box  className={classes.descriptionPoints}>
                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography variant="body2" className={classes.point} style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Developed python REST API using flask.
                                </Typography>
                            </Box>

                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Integrated an efficient and fast algorithm to parse logs and give insights.
                                </Typography>
                            </Box>

                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Migrated data from psql to Elasticsearch
                                </Typography>
                            </Box>

                            <Box style={{display:'flex',flexDirection:'row'}}>
                                <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                <Typography className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                • Worked on writing test-scripts using robot framework, to discover security vulnerabilities
                                </Typography>
                            </Box>

                            
                        </Box>
                    </Box>
                
                </Box>

                <br></br>
                <br></br>
                {/*ResoluteAI.in */}
                <Box className={classes.contentContainer}>

                <Box  className={classes.listContainer,"listContainer"}>
                    <List className={classes.list}>
                        <ListItem disablePadding>
                            <ListItemButton selected={selectedIndex===1} style={{borderLeft:selectedIndex==1?'1px solid #64ffda':'none'}}> 
                                <ListItemText primary="ResoluteAI.in" style={{color:'#64ffda'}}/>
                            </ListItemButton>
                        </ListItem>

                       
                    </List>
                </Box>
                <Box className={classes.descriptionContainer} >
                    <Box  className={classes.roleContainer}>
                        <Typography className={classes.roleName} style={{color:'#ccd6f6',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",fontSize:'22px'}}>Full stack developer intern</Typography>
                        <Typography  className={classes.companyName} style={{color:'#64ffda',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",margin:'0px 5px 0px 5px',fontSize:'22px'}}>@ResoluteAI.in</Typography>
                    </Box>
                    <Typography className={classes.roleTime} style={{color:'#495670',fontSize:'13px',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Sep 2021 - Dec 2021</Typography>
                    
                    {/*Content */}
                    <Box  className={classes.descriptionPoints}>
                        <Box style={{display:'flex',flexDirection:'row'}}>
                            <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                            <Typography variant="body2" className={classes.point} style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Write modern, performant, maintainable code for a diverse array of client and internal projects
                            </Typography>
                        </Box>

                        <Box style={{display:'flex',flexDirection:'row'}}>
                            <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                            <Typography className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Worked on design and development of modern UI  using Material-UI,chart-js and many other.
                            </Typography>
                        </Box>

                        <Box style={{display:'flex',flexDirection:'row'}}>
                            <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                            <Typography className={classes.point} className={classes.point} variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                                Integrated support for backend processes using redux and firebase services.
                            </Typography>
                        </Box>

                        <Box style={{display:'flex',flexDirection:'row'}}>
                            <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                            <Typography className={classes.point}  variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px'}}>
                               Developed a complete super-admin web app for variety of services like adding new users,adding data,scheduling webinars,etc.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                
                </Box>
                
            </Box>
            
        
        </div>
    )
}

export default WorkExperience
